import { isSmartPhone } from '../../utilities/helper';
import MatchMakingPlayerFoundWeb from './index_web';
import MatchMakingPlayerFoundMWeb from './index_mWeb';

const MatchMakingPlayerFound = ({ isLandscape }: any) => {
  if (isSmartPhone && !isLandscape) {
    return <MatchMakingPlayerFoundMWeb />;
  }
  return <MatchMakingPlayerFoundWeb isLandscape={isLandscape} />;
};

export default MatchMakingPlayerFound;
